import { Select } from "antd";
import { useProjectParticipants } from "hooks/project-participants";

const { Option } = Select;

function ResponsibleDesignFirmsDropdown(props: any) {
  const { value, onChange, disabled } = props;
  const { projectParticipants } = useProjectParticipants();
  const designFirms = projectParticipants?.drCompanies;

  return (
    <Select
      className="w-full"
      value={value || undefined}
      allowClear
      onChange={onChange}
      showSearch
      filterOption={(inputValue, option: any) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
      disabled={disabled}
      data-testid="index-select-responsible-design-firm"
    >
      {designFirms.map((cmpny: any) => {
        return (
          <Option
            key={cmpny.vendor_id}
            value={cmpny.vendor_id}
            label={`${cmpny?.subscription_vendor?.name}`}
          >
            <div className="text-[14px] text-ciq-gray-800">
              {cmpny?.subscription_vendor?.name}
            </div>
          </Option>
        );
      })}
    </Select>
  );
}

export default ResponsibleDesignFirmsDropdown;
